import { render } from "./ART.vue?vue&type=template&id=6c3569ea"
import script from "./ART.vue?vue&type=script&lang=js"
export * from "./ART.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__